<div class="modal-header">
  <h4 class="modal-title text-truncate" id="modal-title" style="margin-left: 10px;" title="{{ endpointDetails.endPointName }}"> Edit - {{endpointDetails.endPointName}}</h4>
  <button type="button" class="close text-white" (click)="modal.close()">
    <span style="color: black;" aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" id="modal-body">
  <div class="common-section ml-3" [ngClass]="createNewEndpointForm.value.id && (createNewEndpointForm.value.endPointType === 'REST' || createNewEndpointForm.value.endPointType === 'SOAP') ? 'mt-n4 ml-n2' : ''"><br>
    <div class="common-heading" *ngIf="webConfiguration === 'PLAYWRIGHT' && webConfiguration !== null">
      <span class="common-heading text-muted" style="float: right;font-size: 14px;"> Web Automation Tool : {{webConfiguration}}</span>
    </div>

    <form [formGroup]="createNewEndpointForm" class="common-form-style">
      <div class="form-group row full-width">
        <div class="col-6">
          <label for="flowname" class="font-bold" [ngbTooltip]="constants.newEndpointName" placement="right">Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control form-control-sm" placeholder="Example : Test_001_GenerateToken" id="flowname" name="flowname" formControlName="name" [class.is-invalid]="submitted && f.name.errors" [class.is-valid]="submitted && !f.name.errors" />
        </div>
        <div class="col-6">
          <label for="project" class="font-bold" [ngbTooltip]="constants.newEndpointProject">Project <span class="text-danger">*</span></label>
          <ng-select [attr.data-items]="myProjectsList | customList:'name'" [attr.data-locator]="'project'" [attr.data-value]="createNewEndpointForm.value.project?.name" class="custom-style" [items]="myProjectsList" bindLabel="name" id="project" placeholder="Select project" (change)=getProjectConfiguration($event) formControlName="project" [searchable]="true" [class.is-invalid]="submitted && f.project.errors" [class.is-valid]="submitted && !f.project.errors">
            <ng-template ng-option-tmp let-item="item">
              <div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="form-group row full-width">
        <div class="col-6">
          <label for="description" class="font-bold" [ngbTooltip]="constants.newEndpointDescription">Description</label>
          <textarea name="name" id="description" class="form-control" rows="1" cols="80" placeholder="Description" formControlName="description"></textarea>
        </div>
        <div [ngClass]="showWebflow() ? 'col-5' : 'col-6'" *ngIf="!displayCURLInput">
          <label for="project" class="font-bold" [ngbTooltip]="constants.newEndpointType">Type<span class="text-danger">*</span></label>
          <ng-select class="custom-style" id="endpoint" [items]="endPointTypes" bindLabel="label" [clearable]="false" formControlName="endPointType" placeholder="Select Endpoint type" [readonly]="isEndpointTypeReadonly" required></ng-select>
        </div>

        <div class="col-6" *ngIf="displayCURLInput">
          <label for="endpoint-type">Type <span class="text-danger">*</span> </label>
          <select class="form-control form-control-sm" formControlName="endPointType" id="endpoint">
            <option value="REST">REST</option>
            <option value="SOAP">SOAP</option>
          </select>
        </div>
        <div class="col-1" *ngIf="showWebflow()">
          <div class="text-center customeFlow">
            <label for="subFlow" class="font-bold mt-2" [ngbTooltip]="constants.newEndpointSubflow">SubFlow</label> <br>
            <input type="checkbox" id="subFlow" formControlName="subFlow" (change)="changeSubFlow($event)">
          </div>
        </div>
      </div>
      <div *ngIf="createNewEndpointForm.value.endPointType">
        <div *ngIf="createNewEndpointForm.value.endPointType.name === 'REST' || createNewEndpointForm.value.endPointType === 'REST' || createNewEndpointForm.value.endPointType.name === 'SOAP' || createNewEndpointForm.value.endPointType === 'SOAP' ">
          <app-new-endpointflow [endpointModalEdited]="true" [endpointDetails]="endpointDetails" [endpointForm]="createNewEndpointForm" (updateBulkValue)="updateBulkValue($event)" (updateRequestBulkValue)="updateRequestBulkValue($event)" (updateBodyFormDataBulkValue)="updateBodyFormDataBulkValue($event)" (bodyTypeEditOptionVal)="bodyTypeEditOptionGet($event)" [projectConfiguration]="webConfiguration" [submitted]="submitted"></app-new-endpointflow>
        </div>

        <div *ngIf="(createNewEndpointForm.value.endPointType === 'WEB' || createNewEndpointForm.value.endPointType?.name === 'WEB') && createNewEndpointForm.value.subFlow === false">
          <app-new-webflow [webFlowFormVal]="createNewEndpointForm" [submitted]="submitted"></app-new-webflow>
        </div>
        <!-- <div *ngIf="createNewEndpointForm.value.endPointType === 'WEBSUB'">
          <app-new-websubflow></app-new-websubflow>
        </div> -->
        <!-- <div *ngIf="createNewEndpointForm.value.endPointType === 'MOBILE'">
          <app-new-mobileflow></app-new-mobileflow>
        </div> -->
      </div>
    </form>
  </div>
</div>
<div class="modal-footer confirm-footer">
  <button type="submit" class="btn relay-btn relay-createbtn" (click)="onSubmit()" [ngClass]="createNewEndpointForm.value?.id ?'update':'create'" [disabled]="createNewEndpointForm.invalid">{{createNewEndpointForm.value?.id ? 'Update' : 'Create'}}</button>
  <button type="button" class="btn relay-btn cancel" (click)="cancel()">Cancel</button>
</div>
